import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/AboutUsPage.module.css';
import videoBackground from '../styles/background.mp4';

const AboutUsPage = () => {
  const navigate = useNavigate();
const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className={styles.aboutUsPageContainer}>
      <video className={styles.aboutUsVideoBackground} autoPlay loop muted>
        <source src={videoBackground} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

    <header className={styles.aboutUsHeaderMenu}>
  <div onClick={() => navigate('/')} className={styles.aboutUsLogo}>
    Full Trucking Service
  </div>

  {/* Buton hamburger pentru meniul mobil */}
  <div className={styles.hamburgerAboutUs} onClick={() => setIsMenuOpen(!isMenuOpen)}>
    ☰
  </div>

  <nav className={`${styles.navMenuAboutUs} ${isMenuOpen ? styles.activeAboutUs : ''}`}>
    <ul>
      <li onClick={() => navigate('/about')}>About Us</li>
      <li onClick={() => navigate('/services')}>Services</li>
      <li onClick={() => navigate('/contact')}>Contact</li>
      <li onClick={() => navigate('/pricing')}>Register</li>
    </ul>
  </nav>
</header>


      <div className={styles.aboutUsMainContent}>
        <div className={styles.aboutustextSection}>
          <h1>About Us</h1>
          <p>
           Full Trucking Service, also known as FTS, is a software solution owned and developed by Two Brothers Freight Solutions (2-BFS). It was created with one clear purpose: to make the day-to-day work of transportation and logistics companies more efficient, more transparent, and more profitable.
          </p>
          
          <p>
           The transport industry moves fast and is highly competitive. Every hour counts, and every error costs money. FTS was designed as a reliable partner for dispatchers, drivers, and company managers who need real-time control over their operations. By combining advanced technology with practical tools, the platform transforms the way trucking companies plan, monitor, and complete their work.
          </p>
         
          <p>
            With FTS, users can manage loads, assign drivers, track equipment, monitor deliveries, and communicate instantly across teams. The system provides accurate reporting, smart automation, and a centralized hub for all critical information. Tasks that once took hours are reduced to minutes, and the risk of miscommunication or lost data is eliminated.
          </p>
          
          <p>
           What makes FTS different is that it was built by people with direct experience in transportation. We understand the challenges of keeping trucks on the road, coordinating with shippers and consignees, and meeting customer demands under pressure. FTS was developed not as a generic product, but as a solution tailored to the real problems companies face every single day.
          </p>
          Our mission is to help businesses in the trucking sector save time, cut unnecessary costs, and deliver better service to their clients. Our vision is to see FTS become the industry’s most trusted standard in transport management, adaptable to companies of every size, from small fleets to large enterprises.
          <p>
            At Two Brothers Freight Solutions (2-BFS) we believe that technology should not complicate work, it should simplify it. FTS is more than a software application; it is a business partner that grows with you, supports your operations, and provides a foundation for long-term success in an ever-changing market.
          </p>
        
          <h2>Join the Full Trucking Service Community</h2>
          <p>
            When you choose Full Trucking Service, you’re not just getting an application; you’re joining a community of
            trucking professionals who are passionate about making the industry better. Together, we can transform the
            way trucking companies operate, making the industry more efficient, sustainable, and profitable for everyone
            involved.
          </p>
        </div>
      </div>

<footer className={styles.aboutusFooter}>
  <a
    href="https://2-bfs.com/terms-and-conditions"
    target="_blank"
    rel="noopener noreferrer"
    className={styles.aboutusFooterlink}
  >
    Terms of Service
  </a>
  <a
    href="https://2-bfs.com/privacy-policy"
    target="_blank"
    rel="noopener noreferrer"
    className={styles.aboutusFooterlink}
  >
    Privacy Policy
  </a>
  <a
    href="https://2-bfs.com/panda-help"
    target="_blank"
    rel="noopener noreferrer"
    className={styles.aboutusFooterlink}
  >
    Help
  </a>
</footer>

    </div>
  );
};

export default AboutUsPage;
